const colorToken = {
  colorPrimary: '#C1FF00',
  colorPrimaryHover: '#A8E600',
  colorPrimaryActive: '#76CC00',
  colorPrimaryRgb: '193, 255, 0',
  colorChatBg: '#1A1A1A',
  colorHeavy: '#0F0F0F',
  colorAssist1: '#2E2E2E',
  colorAssist1Alpha20: 'rgba(46, 46, 46, 0.2)',
  colorAssist2: '#3A3A3A',
  colorAssist3: '#B0FF4D',
  colorAssist4: '#242424',
  colorAssist5: '#FFFFFF',
  colorAssist6: '#333333',
  colorAssist7: '#FFB020',
  colorBgBase: '#222222',
  colorBgContainer: '#1E1E1E',
  colorBgLayout: '#161616',
  colorBgChat: '#222222',
  colorTextBase: '#FFFFFF',
  colorTextSecondary: '#C7C7C7',
  colorTextTertiary: '#A3A3A3',
  colorTextDisabled: '#6F6F6F',
  colorTextOnLightBase: '#1F1F1F',
  colorTextOnLightSecondary: '#555555',
  colorTextOnLightTertiary: '#777777',
  colorBorder: '#2A2A2A',
  colorBorderSecondary: '#3A3A3A',
  colorError: '#FF4D4F',
  colorSuccess: '#00E676',
  colorPrimaryBg: 'rgba(193, 255, 0, 0.10)',
  colorPrimaryBgHover: 'rgba(193, 255, 0, 0.20)',
  colorPrimaryBorder: '#C1FF00',
  colorPrimaryText: '#C1FF00',
  colorPrimaryTextHover: '#A8E600',
  colorPrimaryTextActive: '#76CC00',
  borderRadius: 12,
  radiusCard: '12px',
  spacingSection: '24px',
};

// 导出CSS变量版本，用于生成CSS样式表
export const cssColorVariables = `:root {
  --color-primary: ${colorToken.colorPrimary};
  --color-chat-bg: ${colorToken.colorChatBg};
  --color-primary-hover: ${colorToken.colorPrimaryHover};
  --color-primary-active: ${colorToken.colorPrimaryActive};
  --color-primary-rgb: ${colorToken.colorPrimaryRgb};
  --color-heavy: ${colorToken.colorHeavy};
  --color-assist-1: ${colorToken.colorAssist1};
  --color-assist-1-alpha-20: ${colorToken.colorAssist1Alpha20};
  --color-assist-2: ${colorToken.colorAssist2};
  --color-assist-3: ${colorToken.colorAssist3};
  --color-assist-4: ${colorToken.colorAssist4};
  --color-assist-5: ${colorToken.colorAssist5};
  --color-assist-6: ${colorToken.colorAssist6};
  --color-assist-7: ${colorToken.colorAssist7};
  --color-bg-base: ${colorToken.colorBgBase};
  --color-bg-container: ${colorToken.colorBgContainer};
  --color-bg-layout: ${colorToken.colorBgLayout};
  --color-bg-chat: ${colorToken.colorBgChat};
  --color-text-base: ${colorToken.colorTextBase};
  --color-text-secondary: ${colorToken.colorTextSecondary};
  --color-text-tertiary: ${colorToken.colorTextTertiary};
  --color-text-disabled: ${colorToken.colorTextDisabled};
  --color-text-on-light-base: ${colorToken.colorTextOnLightBase};
  --color-text-on-light-secondary: ${colorToken.colorTextOnLightSecondary};
  --color-text-on-light-tertiary: ${colorToken.colorTextOnLightTertiary};
  --color-border: ${colorToken.colorBorder};
  --color-border-secondary: ${colorToken.colorBorderSecondary};
  --color-error: ${colorToken.colorError};
  --color-success: ${colorToken.colorSuccess};
  --color-primary-bg: ${colorToken.colorPrimaryBg};
  --color-primary-bg-hover: ${colorToken.colorPrimaryBgHover};
  --color-primary-border: ${colorToken.colorPrimaryBorder};
  --color-primary-text: ${colorToken.colorPrimaryText};
  --color-primary-text-hover: ${colorToken.colorPrimaryTextHover};
  --color-primary-text-active: ${colorToken.colorPrimaryTextActive};
  --radius: ${colorToken.radiusCard};
  --radius-card: ${colorToken.radiusCard};
  --spacing-section: ${colorToken.spacingSection};
}`;

export default colorToken;
